import gql from "graphql-tag"
import { useMutation } from "@apollo/react-hooks"

const setShopifyIntegrationMutation = gql`
  mutation setShopifyAppIntegration(
    $shopName: String!
    $siteId: UUID!
    $shopifyStoreFrontToken: String
    $shopifyAppToken: String!
  ) {
    setShopifyAppIntegration(
      shopName: $shopName
      siteId: $siteId
      shopifyAppToken: $shopifyAppToken
      shopifyStoreFrontToken: $shopifyStoreFrontToken
    ) {
      success
      message
    }
  }
`

export function useSetShopifyAppIntegration() {
  const [shopifyMutation] = useMutation(setShopifyIntegrationMutation)

  return {
    setShopifyAppIntegration: (siteId: string) => {
      const shopName = localStorage.getItem(`gatsby:shopifyshop`)
      const shopifyAppToken = localStorage.getItem(`gatsby:shopifyapptoken`)
      const shopifyStoreFrontToken = localStorage.getItem(
        `gatsby:shopifyappstorefronttoken`
      )

      return shopifyMutation({
        variables: {
          shopName,
          shopifyAppToken,
          shopifyStoreFrontToken,
          siteId,
        },
      })
    },
    clearShopifyStorageInfo: () => {
      localStorage.removeItem(`gatsby:shopifyshop`)
      localStorage.removeItem(`gatsby:shopifyapptoken`)
      localStorage.removeItem(`gatsby:shopifyappstorefronttoken`)
    },
  }
}
